module.exports = __webpack_public_path__ + "static/media/shield-icon.4974d2db.svg";